var _g, _animate, _animate2, _animate3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScenarioSwitch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 125.08,
    y: 90.8,
    width: 260.98,
    height: 260.98,
    rx: 11.34,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.31,352.9H137.83A13.88,13.88,0,0,1,124,339V103.55a13.88,13.88,0,0,1,13.87-13.87H373.31a13.88,13.88,0,0,1,13.87,13.87V339A13.88,13.88,0,0,1,373.31,352.9Zm-235.48-261a11.65,11.65,0,0,0-11.63,11.63V339a11.64,11.64,0,0,0,11.63,11.62H373.31A11.63,11.63,0,0,0,384.93,339V103.55a11.64,11.64,0,0,0-11.62-11.63Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.26,185.19v34.5h-3.18V179.86l1.67,1.68A5.15,5.15,0,0,1,128.26,185.19Z",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.08,222.88h3.18v34.5a5.16,5.16,0,0,1-1.51,3.66l-1.67,1.67Z",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.87,185.19v34.5h3.18V179.86l-1.67,1.68A5.15,5.15,0,0,0,382.87,185.19Z",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.05,222.88h-3.18v34.5a5.16,5.16,0,0,0,1.51,3.66l1.67,1.67Z",
    style: {
      fill: "#010101"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#777"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.31,337a1.13,1.13,0,0,1-.46-.44,18,18,0,0,1-.09-3.42c0-2.19,0-3.36,0-3.52a.85.85,0,0,1,1.38-.48c.31.28.32.3.33,1.71v1.26h5.68v-1.25c0-1.15,0-1.28.09-1.44a.78.78,0,0,1,.78-.47.82.82,0,0,1,.81.59c0,.12,0,1.23,0,3.55v3.38l-.11.17a.85.85,0,0,1-1.19.27c-.39-.25-.4-.31-.4-1.77v-1.26h-5.68v1.27c0,1.24,0,1.27-.12,1.45a.82.82,0,0,1-.7.43A1.31,1.31,0,0,1,227.31,337Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.9,337a.9.9,0,0,1-.45-.48c0-.11,0-1.34,0-3.62v-3.45l.19-.19a.81.81,0,0,1,.76-.27.56.56,0,0,1,.46.23,1.42,1.42,0,0,1,.24.39c.07.25.07,6.58,0,6.83a1,1,0,0,1-.49.57A.91.91,0,0,1,237.9,337Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.07,337a1.11,1.11,0,0,1-.44-.42,17.42,17.42,0,0,1-.08-3.4,27.59,27.59,0,0,1,.07-3.43,1.3,1.3,0,0,1,.31-.43,1.2,1.2,0,0,1,1-.39c.42,0,.61.15,1.18.74l1,1.09,1.54,1.61,1.59,1.65.62.65,0-2.58a12.67,12.67,0,0,1,.1-2.73.89.89,0,0,1,1.4-.17.77.77,0,0,1,.17.26c0,.09,0,1.2,0,3.39,0,3.64,0,3.43-.34,3.8a1.21,1.21,0,0,1-.87.42c-.47,0-.76-.12-1.29-.66l-2.59-2.7-1.74-1.81-.57-.58v5.07l-.1.21a.82.82,0,0,1-.74.46A.65.65,0,0,1,241.07,337Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.89,336.94a2.46,2.46,0,0,1,.37-4.78c.43-.06,5.11-.06,5.35,0a1,1,0,0,1,.57.48.72.72,0,0,1,.05.41.81.81,0,0,1-.44.7l-.18.11-2.65,0c-3,0-2.83,0-3,.41a.69.69,0,0,0,.08.74c.24.31.15.3,3.16.29l2.7,0,.28-.11a2.45,2.45,0,0,0,1.4-1.37,2.65,2.65,0,0,0,0-1.64,2.34,2.34,0,0,0-1.45-1.4,19,19,0,0,0-3.39-.11c-3.56,0-3.33,0-3.61-.38a.66.66,0,0,1-.14-.51c0-.31,0-.33.19-.52a1.08,1.08,0,0,1,.31-.26c.1,0,1-.05,3.42,0h3.27l.44.16a4.06,4.06,0,0,1,1.77,1.16,5.06,5.06,0,0,1,.33.39.57.57,0,0,0,.11.19,4.05,4.05,0,0,1,.5,1.15,4.06,4.06,0,0,1-3.06,4.93,15.69,15.69,0,0,1-3.23.1C253.23,337,253.22,337,252.89,336.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.34,337a1.79,1.79,0,0,1-.77-.49c-.18-.2-1.18-2-2.14-3.75-.1-.2-.34-.61-.52-.94-.85-1.51-1-1.8-1-2a.88.88,0,0,1,.79-.86c.47,0,.73.16,1.1.85.54,1,2.9,5.29,2.94,5.34s.09,0,.14-.16l.25-.46.31-.55c.41-.76,1.27-2.33,1.66-3,.24-.42.53-.95.65-1.19.35-.65.54-.81,1-.81a.85.85,0,0,1,.69.34c.13.16.14.21.14.51v.34l-.46.81c-.4.71-1.37,2.48-1.91,3.46-.09.17-.21.38-.26.46s-.15.28-.23.43-.19.35-.24.42l-.2.37a2.06,2.06,0,0,1-.82.81,1.44,1.44,0,0,1-.63.13A2.19,2.19,0,0,1,267.34,337Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,337a2.67,2.67,0,0,1-1.52-1.17,2.47,2.47,0,0,1,1.83-3.65c.23,0,1.37-.05,2.88,0l2.5,0,.18.14a1.26,1.26,0,0,1,.28.33.85.85,0,0,1-.57,1.22c-.13,0-1,.05-2.7.05h-2.52l-.16.11a.73.73,0,0,0,0,1.24c.17.1.21.1,2.8.1,2.77,0,2.81,0,3.32-.23a2.33,2.33,0,0,0,1.17-1.24,1.88,1.88,0,0,0,.17-.91,2.3,2.3,0,0,0-1.25-2c-.49-.27-.52-.27-3.79-.27-2.82,0-3,0-3.19-.09a.84.84,0,0,1-.13-1.5l.13-.11h6.71l.37.13a3.94,3.94,0,0,1,1.34.74,3.85,3.85,0,0,1,1.07,1.3,3.41,3.41,0,0,1,.44,1.68,3.11,3.11,0,0,1-.08,1.05,5.06,5.06,0,0,1-.29.83,2.94,2.94,0,0,1-.53.84,4.15,4.15,0,0,1-2.09,1.38c-.31.1-.45.1-3.26.11A25.72,25.72,0,0,1,275,337Z"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "hinava_random_uuid_scenario_switch_blink",
    attributeName: "fill",
    values: "#777;#00ffdc;#777",
    begin: "hinava_random_uuid_scenario_switch_hand_out.end+1s",
    end: "hinava_random_uuid_scenario_switch_hand_out.end+5.2s;",
    dur: "0.7s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.1,30.85a4.14,4.14,0,0,0,0,8.28A45,45,0,0,1,427,84.06a4.15,4.15,0,0,0,8.29,0A53.27,53.27,0,0,0,382.1,30.85Z",
    style: {
      fill: "#f26850"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,53.65a2.84,2.84,0,1,0,0,5.68,30.86,30.86,0,0,1,30.82,30.82,2.84,2.84,0,1,0,5.68,0A36.54,36.54,0,0,0,376,53.65Z",
    style: {
      fill: "#f26850"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.87,84.06a4.14,4.14,0,1,0,8.28,0,45,45,0,0,1,44.93-44.93,4.14,4.14,0,0,0,0-8.28A53.27,53.27,0,0,0,61.87,84.06Z",
    style: {
      fill: "#f26850"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.67,90.15a2.84,2.84,0,1,0,5.68,0,30.86,30.86,0,0,1,30.82-30.82,2.84,2.84,0,1,0,0-5.68A36.54,36.54,0,0,0,84.67,90.15Z",
    style: {
      fill: "#f26850"
    }
  }), _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    id: "hinava_random_uuid_scenario_switch_beep",
    attributeName: "fill-opacity",
    values: "0;1;0;1;0",
    begin: "hinava_random_uuid_scenario_switch_hand_out.end",
    dur: "1s"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M316.07,263v12h-12V263h12m.17-3H303.92a2.83,2.83,0,0,0-2.83,2.83v12.32a2.84,2.84,0,0,0,2.83,2.84h12.32a2.84,2.84,0,0,0,2.83-2.84V262.82a2.83,2.83,0,0,0-2.83-2.83Z",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.25 276.48 202.33 263.09 210.12 276.48 194.25 276.48",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.3,266l5.21,9H196.9l5.4-9m0-5.11a.79.79,0,0,0-.67.34l-9.52,15.79c-.26.43.1.93.66.93h18.73c.55,0,.91-.5.66-.92L203,261.27a.75.75,0,0,0-.66-.35Z",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.9,167.6a5.76,5.76,0,1,1-5.77,5.76,5.77,5.77,0,0,1,5.77-5.76m0-3a8.76,8.76,0,1,0,8.76,8.76,8.77,8.77,0,0,0-8.76-8.76Z",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317,
    y1: 167.16,
    x2: 304.61,
    y2: 179.56,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 304.61,
    y1: 167.16,
    x2: 317,
    y2: 179.56,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 202.55,
    cy: 174.49,
    r: 14.06,
    style: {
      fill: "#f16951"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.55,200.35a26,26,0,1,1,26-26A26,26,0,0,1,202.55,200.35Zm0-47.51a21.66,21.66,0,1,0,21.65,21.65A21.73,21.73,0,0,0,202.55,152.84Z",
    style: {
      fill: "#f16951"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.08,
    cy: 175.34,
    r: 14.06,
    style: {
      fill: "#f16951"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.08,201.2a26,26,0,1,1,26-26A26,26,0,0,1,310.08,201.2Zm0-47.51a21.65,21.65,0,1,0,21.65,21.65A21.72,21.72,0,0,0,310.08,153.69Z",
    style: {
      fill: "#f16951"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.25,310.77c-2.16-22-15-25.45-21.25-25.75a6.19,6.19,0,0,1-4.92-3.08c-5.24-9.34-13-11.6-19.5-11.6a17.86,17.86,0,0,0-2.36.1h-.52a5.9,5.9,0,0,1-5.64-7.39c5.13-20.11,18.27-66.08,18.27-66.08,4.1-12.22-5.85-20.73-15.7-20.73-6.06,0-12.11,3.28-14.58,11l-18.37,61.26a8.53,8.53,0,0,1-8.31,6.16,8.65,8.65,0,0,1-8.31-6.06l-17.55-54.49c-2-8.72-8.72-12.52-15.39-12.52-9.55,0-19.19,7.7-16.22,20.12l19,78.81a5.88,5.88,0,0,1-4.31,7.08c-6.16,1.54-15.09,6.67-16.32,22.58-1.44,19.39,27.2,57.26,32.74,65.27a5.72,5.72,0,0,1,1,2.87l2.88,26c.2,3.08,2.77,4.83,5.85,4.83h71.73c3.08,0,5.64-1.75,5.85-4.83l2.36-23.91a5.33,5.33,0,0,1,1-2.77C321,370,346.61,336.12,344.25,310.77Z",
    style: {
      fill: "#fcd4c5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.05,309.65c-1.23-12.73-5.65-22.48-13.24-28.94a32,32,0,0,0-16.11-7.29,32.9,32.9,0,0,0-23.3-14.78c5.54-20.93,15.29-55.11,16.22-58.29,2.77-8.62,1.54-17.24-3.49-24.22a29.39,29.39,0,0,0-23.61-11.8h0c-12.11,0-22.06,7.39-25.86,19.29,0,.11,0,.11-.1.21l-15.5,51.52L236.7,190.91c-3.29-12.83-13.75-21.14-26.79-21.14a29.57,29.57,0,0,0-23,10.88c-5.24,6.67-7,15.08-4.83,23.91l17.65,73.58a31.86,31.86,0,0,0-10.26,7.39c-5.44,6-8.62,14-9.34,23.81-1.43,19.09,15.6,46,32.53,69.68.52.72,1,1.43,1.44,2l2.77,25.14a17.84,17.84,0,0,0,17.75,16.21h71.74a17.87,17.87,0,0,0,17.75-16.42l2.16-22.67.61-.93C340.65,363,358.41,334.48,356.05,309.65Zm-41.36,71-2.36,23.6c-.21,3.08-2.77,4.83-5.85,4.83H234.75c-3.08,0-5.65-1.75-5.85-4.83L226,378a5.75,5.75,0,0,0-1-2.77c-5.44-8-34.18-45.67-32.74-65.16,1.13-15.91,10.16-20.94,16.32-22.48a6,6,0,0,0,4.31-7.08l-19-78.71c-3-12.42,6.67-20.11,16.22-20.11,6.67,0,13.34,3.79,15.39,12.51l17.55,54.5a8.65,8.65,0,0,0,8.31,6.05,8.45,8.45,0,0,0,8.31-6.16l18.37-61.26c2.47-7.7,8.52-11,14.58-11,9.75,0,19.7,8.52,15.7,20.73,0,0-13.14,46-18.27,66.09a5.94,5.94,0,0,0,5.64,7.39h.52a16.25,16.25,0,0,1,2.36-.11c6.36,0,14.26,2.26,19.5,11.6a5.91,5.91,0,0,0,4.92,3.08c6.26.31,19.19,3.69,21.25,25.76,2.46,25.34-23.3,59.42-28.43,67A4.45,4.45,0,0,0,314.69,380.66Z",
    style: {
      fill: "#010101"
    }
  }), _animate2 || (_animate2 = /*#__PURE__*/React.createElement("animate", {
    id: "hinava_random_uuid_scenario_switch_hand_in",
    attributeName: "fill-opacity",
    from: 0,
    to: 1,
    begin: "0.5s;hinava_random_uuid_scenario_switch_blink.end+1s",
    dur: "1.5s",
    fill: "freeze"
  })), _animate3 || (_animate3 = /*#__PURE__*/React.createElement("animate", {
    id: "hinava_random_uuid_scenario_switch_hand_out",
    attributeName: "fill-opacity",
    from: 1,
    to: 0,
    begin: "hinava_random_uuid_scenario_switch_hand_in.end+1s",
    dur: "1s",
    fill: "freeze"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenarioSwitch);
export default __webpack_public_path__ + "static/media/scenario-switch.5a4cb6426740364eca0af107a4f67e64.svg";
export { ForwardRef as ReactComponent };